/* eslint-disable prettier/prettier */
/* eslint-disable */

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function RotatingCardFront({ color, image, icon, title, description }) {
  return (
    <MKBox
  display="flex"
  justifyContent="center"
  alignContent="center"
  borderRadius="lg"
  coloredShadow={color}
  width="100%"
  position="relative"
  zIndex={2}
  sx={{
    backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
      `${linearGradient(
        rgba(gradients[color] ? gradients[color].main : gradients.info.main, 0.25),
        rgba(gradients[color] ? gradients[color].main : gradients.info.main, 0.25)
      )}, url(${image})`,
    backgroundSize: "cover",
    backfaceVisibility: "hidden",
    overflow: "hidden", // Hindrer at tekst går utenfor
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.3)", // Mørkt filter over bildet
      zIndex: 1, // Sørger for at overlayet er under teksten
    },
  }}
>
  <MKBox py={12} px={3} textAlign="center" lineHeight={1} sx={{ overflow: "hidden", zIndex: 2 }}>
    {icon && (
      <MKTypography variant="h2" color="white" my={2} sx={{ wordWrap: "break-word" }}>
        {typeof icon === "string" ? <Icon sx={{ color: "white" }}>{icon}</Icon> : icon}
      </MKTypography>
    )}
    <MKTypography
      variant="h3"
      color="white"
      gutterBottom
      sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        fontSize: {
          xs: "5vw",
          sm: "4vw",
          md: "2.8vw",
          lg: "1.8vw",
        },
      }}
    >
      {title}
    </MKTypography>

    <MKTypography
      variant="body2"
      color="white"
      opacity={0.8}
      sx={{ wordWrap: "break-word", whiteSpace: "normal", overflow: "hidden" }}
    >
      {description}
    </MKTypography>
  </MKBox>
</MKBox>
  );
}

// Setting default props for the RotatingCardFront
RotatingCardFront.defaultProps = {
  color: "info",
  icon: "",
};

// Typechecking props for the RotatingCardFront
RotatingCardFront.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  image: PropTypes.string.isRequired,
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
};

export default RotatingCardFront;
